import React from 'react';
import {Outlet} from 'react-router-dom';
import styles from "./AssessmentWrapper.module.scss";

export const AssessmentWrapper = () => (
  <div className={styles.wrapper}>
      <Outlet/>
  </div>
);
